var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('div',{staticClass:"empty-content__icon"},[_c('img',{attrs:{"src":require("@/assets/img/yorum-yok.png"),"alt":""}})]),_c('div',{staticClass:"empty-content__title"},[_vm._v("No comments yet. We wonder your comment!")])])
}]

export { render, staticRenderFns }